import styles from './PostsPageContent.module.scss';
import {FC, ReactNode} from "react";
import Image from "next/image";
import bckMedia from "../../public/images/bck-media.png";
import maskOverlay from "../../public/images/mask.png";
import {clsIf, clss} from "../../src/utils";
import Link from 'next/link';
import {ImageWithBlur} from "../ImageWIthBlur/ImageWithBlur";

export const PostsPageContent: FC<{
  title: string
  posts: any[]
  withMask?: boolean
  control?: (largePost: any) => ReactNode
}> = ({
  title,
  posts,
  withMask,
  control,
}) => {
 return       <><div className={styles.screenHeader}>
   <div className={styles.backgroundContainer}>
     <ImageWithBlur src={bckMedia} priority={true} draggable={false} alt={""}
            layout={"responsive"} objectFit={"cover"}/>
   </div>
   <h1><b>{title}</b></h1>
 </div>
   {posts.map(post => <EventPost key={post.title} largePost={post} control={control} withMask={withMask} href={post.href}/>)}
 </>
}


const EventPost: FC<{
  largePost: any
  control?: (largePost: any) => ReactNode
  withMask?: boolean
  href?: string
}> = ({
  largePost,
  control,
  withMask,
  href,
}) => {
  let postEl = <div className={clss(styles.post, styles.large, clsIf(href, styles.clickable))}>
    <div className={styles.image}>
      <ImageWithBlur src={largePost.image} alt={largePost.title} draggable={false} priority={!!largePost.drawingPriority}
             layout={"responsive"} objectFit={"cover"} sizes={"(max-width: 545px) 100vw, 545px"}/>
      {withMask && <div className={styles.overlay}>
          <Image src={maskOverlay} alt={""} draggable={false} priority={true}
                 layout={"responsive"} objectFit={"cover"} sizes={"(max-width: 545px) 100vw, 545px"}/>
      </div>}
    </div>
    <div className={styles.rightColumn}>
      {largePost.date && <div className={styles.tags}><span className={styles.tag}>{largePost.date}</span></div>}
      <h3 className={styles.title}>{largePost.title}</h3>
      <div className={styles.preview}>{largePost.description}</div>
      <div className={styles.controls}>
        {control && control(largePost)}
      </div>
    </div>
  </div>;
  return href ? <Link href={href}><a className={styles.postLink}>{postEl}</a></Link> : postEl
}